<template>
    <FlexContainer 
        :style="scrollStyles"
        :class="scrollClasses"
        v-bind="flexProps"
    >
        <slot />
    </FlexContainer>
</template>

<script>
// Containers
import FlexContainer from './FlexContainer';

// Mixins
import flexProps from '../../mixins/flex-props.js';
import styles from '../../mixins/styles.js';

// Types
import { scrollSnaps, scrollSnapDefault, scrollbarApperance, scrollbarApperanceDefault } from '../../types/ScrollFlex.types.js';

// Utils
import { eligibleProp } from '../../utils/props-utils';

export default {
    name: 'ScrollFlexContainer',
    components: { FlexContainer },
    mixins: [flexProps, styles],
    props: {
        maxWidthPx: {
            type: Number,
            default: 0
        },
        maxHeightPx: {
            type: Number,
            default: 0
        },
        snap: {
            type: String,
            default: scrollSnapDefault,
            validator: eligibleProp(scrollSnaps)
        },
        scrollVisibility: {
            type: String,
            default: scrollbarApperanceDefault,
            validator: eligibleProp(scrollbarApperance)
        }
    },
    computed: {
        flexProps: function() {
            const {
                maxWidthPx,
                maxHeightPx,
                snap,
                scrollVisibility,
                ...flexProps
            } = this.$props
            return flexProps;
        },
        scrollStyles: function() {
            return Object.assign(
                this.maxWidthPx && { maxWidth: `${this.maxWidthPx}px`},
                this.maxHeightPx && { maxHeight: `${this.maxHeightPx}px`}
            );
        },
        scrollClasses: function() {
            return [
                this.cssClasses.pcc__scroll,
                this.scrollVisibility && this.cssClasses[`pcc__scroll__${this.scrollVisibility}`],
                this.snap && this.cssClasses[`pcc__scroll__${this.snap}`]
            ]
        }
    }
}
</script>
